import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, FreeMode } from "swiper/modules";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useTranslation } from "react-i18next";

const slidesData = [
  {
    pairs: [
      [
        {
          src: "https://www.luckco7.com/images/common/lobby/red-blue-duel-enter.png",
          webp: "https://www.luckco7.com/images/common/lobby/red-blue-duel-enter.webp",
          platFormCode: "PP",
          gameType: "LIVE",
          casinoType: "PP-LIVE-042",
        },
        {
          src: "https://www.luckco7.com/images/common/lobby/dragon-tiger-enter.png",
          webp: "https://www.luckco7.com/images/common/lobby/dragon-tiger-enter.webp",
          platFormCode: "PP",
          gameType: "LIVE",
          casinoType: "PP-LIVE-042",
        },
      ],
      [
        {
          src: "https://www.luckco7.com/images/common/lobby/coin-enter.png",
          webp: "https://www.luckco7.com/images/common/lobby/coin-enter.webp",
          platFormCode: "JILI",
          gameType: "SLOT",
          casinoType: "JILI-SLOT-101",
        },
        {
          src: "https://www.luckco7.com/images/common/lobby/7up7down-enter_3.png",
          webp: "https://www.luckco7.com/images/common/lobby/7up7down-enter_3.webp",
          platFormCode: "JILI",
          gameType: "SLOT",
          casinoType: "JILI-SLOT-101",
        },
      ],
      [
        {
          src: "https://www.luckco7.com/images/common/lobby/andarbahar-enter_2.png",
          webp: "https://www.luckco7.com/images/common/lobby/andarbahar-enter_2.webp",
          platFormCode: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-032",
        },
        {
          src: "https://www.luckco7.com/images/common/lobby/rocket-enter_1.png",
          webp: "https://www.luckco7.com/images/common/lobby/rocket-enter_1.webp",
          platFormCode: "VIACASINO",
          gameType: "LIVE",
          casinoType: "VIACASINO-LIVE-016",
        },
      ],
    ],
  },
  {
    pairs: [
      [
        {
          src: "https://www.luckco7.com/images/common/lobby/ghost-enter_1.png",
          webp: "https://www.luckco7.com/images/common/lobby/ghost-enter_1.webp",
          platFormCode: "PT",
          gameType: "SLOT",
          casinoType: "PT-SLOT-149",
        },
        {
          src: "https://www.luckco7.com/images/common/lobby/beer-enter_1.png",
          webp: "https://www.luckco7.com/images/common/lobby/beer-enter_1.webp",
          platFormCode: "JDB",
          gameType: "EGAME",
          casinoType: "JDB-EGAME-010",
        },
      ],
      [
        {
          src: "https://www.luckco7.com/images/common/lobby/roulette-enter_1.png",
          webp: "https://www.luckco7.com/images/common/lobby/roulette-enter_1.webp",
          platFormCode: "PT",
          gameType: "LIVE",
          casinoType: "PT-LIVE-100",
        },
        {
          src: "https://www.luckco7.com/images/common/lobby/coming_1.png",
          webp: "https://www.luckco7.com/images/common/lobby/coming_1.webp",
          platFormCode: "PP",
          gameType: "LIVE",
          casinoType: "PP-LIVE-001",
        },
      ],
    ],
  },
];

const GameSwiper = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const setCasinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoBefore;
  });
  const { t } = useTranslation();
  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
          });
        }
      }
    } else {
      setCasinoBefore(true);
    }
  };
  return (
    <Swiper
      modules={[Pagination, FreeMode]}
      pagination={{ clickable: true }}
      spaceBetween={20}
      slidesPerView={1}
      freeMode
      className="swiper-container game__slider" // same as original
      data-swiper="game"
      data-loop="true"
      data-pagination="true"
    >
      <div className="swiper-wrapper">
        {slidesData.map((slide, i) => (
          <SwiperSlide className="swiper-slide" key={i}>
            <div style={i == 1 ? { paddingLeft:"0"} : {}} className="slide__item">
              {slide.pairs.map((pair, j) => (
                <span className="slide__item__pair" key={j}>
                  {pair.map((item, k) => (
                    <div
                      onClick={() => handel(item)}
                      className="wrapper"
                      style={{ marginBottom: "25px" }}
                      key={k}
                    >
                      <svg
                        style={{ position: "absolute", left: "15px" }}
                        className="pin"
                        fill="none"
                        height="40"
                        width="36"
                        viewBox="0 0 36 40"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M36 40L18 30.8578L0 40V0H36V40Z"
                          fill="#FCFCFC"
                        />
                        <path
                          d="M26.6915 13.0704C27.2992 12.4732 26.9589 11.4461 26.1082 11.3267L22.0245 10.7534C21.6842 10.7056 21.3925 10.4907 21.2467 10.204L19.4237 6.57328C19.0347 5.80891 17.9409 5.80891 17.5763 6.57328L15.7533 10.204C15.6074 10.5145 15.3157 10.7056 14.9754 10.7534L10.8918 11.3267C10.0411 11.4461 9.70077 12.4732 10.3084 13.0704L13.2496 15.9129C13.4927 16.1518 13.6142 16.4862 13.5413 16.8206L12.8364 20.8097C12.7148 21.6457 13.6142 22.2668 14.3677 21.8846L18.0138 19.9975C18.3055 19.8303 18.6701 19.8303 18.9861 19.9975L22.6322 21.8846C23.3857 22.2668 24.2851 21.6457 24.1393 20.8097L23.4344 16.8206C23.3857 16.4862 23.483 16.1518 23.726 15.9129L26.6915 13.0704Z"
                          fill="#020202"
                          fillOpacity="0.5"
                        />
                        <path
                          d="M18 27L36 36.1422V40.1422L18 31L0 40.1422V36.1422L18 27Z"
                          fill="#484848"
                        />
                      </svg>

                      <picture className="pictureClass game__img">
                        <source srcSet={item.webp} type="image/webp" />
                        <img src={item.src} alt="" height="180" width="158" />
                      </picture>
                    </div>
                  ))}
                </span>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </div>

      <div className="swiper-pagination"></div>
    </Swiper>
  );
};

export default GameSwiper;
